import { render, staticRenderFns } from "./SendSmsPostaGuvercini.vue?vue&type=template&id=54ded430&scoped=true"
import script from "./SendSmsPostaGuvercini.vue?vue&type=script&lang=js"
export * from "./SendSmsPostaGuvercini.vue?vue&type=script&lang=js"
import style0 from "./SendSmsPostaGuvercini.vue?vue&type=style&index=0&id=54ded430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ded430",
  null
  
)

export default component.exports